(function () {
  'use strict';

  function formatBadge(element) {
    if (!element) return;

    var match = element.textContent.match(/(\d+)\s*%/);
    if (!match) return;

    var label = match[1] + '% DE DESCONTO';
    if (element.textContent.trim() !== label) element.textContent = label;
  }

  function formatAll(root) {
    if (root.nodeType !== 1 && root !== document) return;

    if (root.matches && root.matches('[data-sale-percentage]')) formatBadge(root);
    root.querySelectorAll('[data-sale-percentage]').forEach(formatBadge);
  }

  function init() {
    formatAll(document);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          formatBadge(mutation.target.parentElement && mutation.target.parentElement.closest('[data-sale-percentage]'));
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) formatAll(node);
        });

        var badge = mutation.target.nodeType === 1 && mutation.target.closest('[data-sale-percentage]');
        if (badge) formatBadge(badge);
      });
    }).observe(document.documentElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
